import { fromJS } from 'immutable';
import { valIn } from '@client/shared/utils/immutableUtils/immutableUtils';
import { fetchEntriesByField } from '@client/connectivity/api.cms';
import { loadFundraisers } from '@client/redux/fundraiser/fundraiserActions';

export const DUCK_EVENT_PAGE_KEY = 'duckEventPageReducer';

const SET_EVENT_PAGE_ERROR = 'SET_EVENT_PAGE_ERROR';
const LOAD_EVENT_PAGE_CMS = 'LOAD_EVENT_PAGE_CMS';

/* REDUCER */
let defaultState = fromJS({
  pageData: {},
});

export default function (state = defaultState, action = {}) {
  switch (action.type) {
    case LOAD_EVENT_PAGE_CMS: {
      return state.merge({ pageData: action.payload, errorMessage: '' });
    }
    case SET_EVENT_PAGE_ERROR: {
      return state.merge({
        errorMessage: action.payload,
      });
    }
    default:
      return state;
  }
}

/* ACTIONS */
export function loadEventPageCms(eventSlug) {
  return function (dispatch) {
    return fetchEntriesByField('event', 'slug', eventSlug).then((response) => {
      return dispatch({
        type: LOAD_EVENT_PAGE_CMS,
        payload: response,
      });
    });
  };
}

export function loadEventPageData(eventSlug) {
  return function (dispatch) {
    const eventPageDataPromises = [
      dispatch(loadEventPageCms(eventSlug)),
      dispatch(loadFundraisers(`?eventName=${eventSlug}`)),
    ];

    return Promise.all(eventPageDataPromises);
  };
}

/* SELECTORS */
export const selectEvent = (state) => {
  return valIn(state[DUCK_EVENT_PAGE_KEY], 'pageData');
};
